import { LOGO_URL } from "@/data/content";

export const Logo = ({ className = "", imgClass = "h-10", showChip = true }) => {
  const img = (
    <img
      src={LOGO_URL}
      alt="Aiga Enable logo"
      className={`${imgClass} w-auto object-contain`}
      width="500"
      height="500"
      loading="eager"
    />
  );
  if (!showChip) return img;
  // Dark tile behind the transparent logo (white/cyan artwork is invisible on
  // white). Arbitrary value so the a11y light-mode token remap can't flip it.
  return (
    <span
      className={`inline-flex items-center justify-center rounded-2xl bg-[#050B14] p-1.5 shadow-[0_6px_28px_-8px_rgba(0,240,255,0.4)] ring-1 ring-teal/20 ${className}`}
    >
      {img}
    </span>
  );
};
